export const REMOTE_CONFIG_KEYS = {
    // Module 96 — a Block Jam first clear pays round(base + perLevel × effective
    // level). Replaced the four reward_level_complete_{easy,medium,hard,expert} tiers.
    REWARD_LEVEL_COMPLETE_BASE: 'reward_level_complete_base',
    REWARD_LEVEL_COMPLETE_PER_LEVEL: 'reward_level_complete_per_level',
    DAILY_REWARD_DAY_1_COINS: 'daily_reward_day_1_coins',
    DAILY_REWARD_DAY_1_GEMS: 'daily_reward_day_1_gems',
    DAILY_REWARD_DAY_2_COINS: 'daily_reward_day_2_coins',
    DAILY_REWARD_DAY_2_GEMS: 'daily_reward_day_2_gems',
    DAILY_REWARD_DAY_3_COINS: 'daily_reward_day_3_coins',
    DAILY_REWARD_DAY_3_GEMS: 'daily_reward_day_3_gems',
    DAILY_REWARD_DAY_4_COINS: 'daily_reward_day_4_coins',
    DAILY_REWARD_DAY_4_GEMS: 'daily_reward_day_4_gems',
    DAILY_REWARD_DAY_5_COINS: 'daily_reward_day_5_coins',
    DAILY_REWARD_DAY_5_GEMS: 'daily_reward_day_5_gems',
    DAILY_REWARD_DAY_6_COINS: 'daily_reward_day_6_coins',
    DAILY_REWARD_DAY_6_GEMS: 'daily_reward_day_6_gems',
    DAILY_REWARD_DAY_7_COINS: 'daily_reward_day_7_coins',
    DAILY_REWARD_DAY_7_GEMS: 'daily_reward_day_7_gems',
    // Module 22 (XP Bar & Profile) — XP per level completion mirrored the old
    // REWARD_LEVEL_COMPLETE_* coin tiers (Module 96 replaced those with a curve;
    // XP keeps its tiers); XP per daily-reward claim scales with
    // day/streak like the coin/gem tiers above, but proportionally smaller since
    // claiming is passive, not active play; the curve keys drive
    // xpRequiredForLevel(level) = XP_CURVE_BASE + (level - 1) * XP_CURVE_INCREMENT.
    XP_LEVEL_COMPLETE_EASY: 'xp_level_complete_easy',
    XP_LEVEL_COMPLETE_MEDIUM: 'xp_level_complete_medium',
    XP_LEVEL_COMPLETE_HARD: 'xp_level_complete_hard',
    XP_LEVEL_COMPLETE_EXPERT: 'xp_level_complete_expert',
    XP_DAILY_REWARD_DAY_1: 'xp_daily_reward_day_1',
    XP_DAILY_REWARD_DAY_2: 'xp_daily_reward_day_2',
    XP_DAILY_REWARD_DAY_3: 'xp_daily_reward_day_3',
    XP_DAILY_REWARD_DAY_4: 'xp_daily_reward_day_4',
    XP_DAILY_REWARD_DAY_5: 'xp_daily_reward_day_5',
    XP_DAILY_REWARD_DAY_6: 'xp_daily_reward_day_6',
    XP_DAILY_REWARD_DAY_7: 'xp_daily_reward_day_7',
    XP_CURVE_BASE: 'xp_curve_base',
    XP_CURVE_INCREMENT: 'xp_curve_increment',
    // Module 24 (Purchase Provider + RevenueCat) — coin/gem amounts per pack tier (the
    // product-id *strings* themselves are fixed, non-tunable catalog identity; see
    // packages/economy/src/iap-catalog.ts). IAP_ROLLOUT_PERCENTAGE (0-100) drives
    // isInRollout()'s stable per-uid staged rollout, not a flat on/off switch.
    IAP_PACK_SMALL_COINS: 'iap_pack_small_coins',
    IAP_PACK_MEDIUM_COINS: 'iap_pack_medium_coins',
    IAP_PACK_MEDIUM_GEMS: 'iap_pack_medium_gems',
    IAP_PACK_LARGE_COINS: 'iap_pack_large_coins',
    IAP_PACK_LARGE_GEMS: 'iap_pack_large_gems',
    IAP_ROLLOUT_PERCENTAGE: 'iap_rollout_percentage',
    // Module 45 (WP-45.6) — coins a brand-new player is granted once, ever. Read by
    // the composition roots' shared starting-grant helper and by nothing else; no
    // UI and no gameplay code knows this number, which is BUG-005's requirement.
    //
    // Retuning it is NOT purely a config change on the main site: the server RPC
    // allowlists the amount as a literal (supabase/migrations/0010_starting_grant.sql),
    // so a new value needs a migration in the same commit or every grant is rejected.
    // A test parses that SQL and fails the gate if the two disagree.
    STARTING_COINS: 'starting_coins',
};
export const FEATURE_FLAG_KEYS = {
    BLOCKJAM_ENABLED: 'blockjam_enabled',
    WATERSORT_ENABLED: 'watersort_enabled',
    // Module 22 (XP Bar & Profile) — gates both XP granting (ProgressionAnalyticsProvider)
    // and the XP bar/level-up toast UI. Defaults true; a kill switch, not a rollout.
    XP_ENABLED: 'xp_enabled',
    // Module 24 (Purchase Provider + RevenueCat) — master kill switch; the staged
    // percentage rollout is IAP_ROLLOUT_PERCENTAGE (REMOTE_CONFIG_KEYS), applied on top.
    IAP_ENABLED: 'iap_enabled',
};
/** DEV defaults (mirrors DEV_DEFAULTS in packages/providers/mock — kept in sync manually). */
export const DEV_RC_DEFAULTS = {
    [FEATURE_FLAG_KEYS.BLOCKJAM_ENABLED]: true,
    [FEATURE_FLAG_KEYS.WATERSORT_ENABLED]: true,
    [FEATURE_FLAG_KEYS.XP_ENABLED]: true,
    [FEATURE_FLAG_KEYS.IAP_ENABLED]: true,
    // Module 96 (WP-96.1) — the reward curve, round(5 + 0.15 × effective level):
    // 5 at level 1, 9 at 25, 14 at 60, 23 at 120. Replaced Module 50's 5/10/20/40
    // tiers and Module 65's 2-coin endless trickle. The Supabase `economy_apply`
    // allowlist accepts any integer 1–60 for this credit (migration 0020), and the
    // game clamps to that range, so the slope can be retuned here or live without
    // a migration as long as the result stays inside it.
    // Module 97 — ×10 coin scale: 50 + 1.5 × level, down to a multiple of 5 (50 at
    // 1 … 230 at 120); the
    // server range is 10–600 (migration 0022).
    [REMOTE_CONFIG_KEYS.REWARD_LEVEL_COMPLETE_BASE]: 50,
    [REMOTE_CONFIG_KEYS.REWARD_LEVEL_COMPLETE_PER_LEVEL]: 1.5,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_1_COINS]: 100,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_1_GEMS]: 0,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_2_COINS]: 120,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_2_GEMS]: 0,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_3_COINS]: 150,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_3_GEMS]: 1,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_4_COINS]: 150,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_4_GEMS]: 0,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_5_COINS]: 200,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_5_GEMS]: 2,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_6_COINS]: 200,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_6_GEMS]: 0,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_7_COINS]: 300,
    [REMOTE_CONFIG_KEYS.DAILY_REWARD_DAY_7_GEMS]: 3,
    [REMOTE_CONFIG_KEYS.XP_LEVEL_COMPLETE_EASY]: 80,
    [REMOTE_CONFIG_KEYS.XP_LEVEL_COMPLETE_MEDIUM]: 160,
    [REMOTE_CONFIG_KEYS.XP_LEVEL_COMPLETE_HARD]: 300,
    [REMOTE_CONFIG_KEYS.XP_LEVEL_COMPLETE_EXPERT]: 500,
    [REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_1]: 20,
    [REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_2]: 25,
    [REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_3]: 30,
    [REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_4]: 30,
    [REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_5]: 40,
    [REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_6]: 40,
    [REMOTE_CONFIG_KEYS.XP_DAILY_REWARD_DAY_7]: 60,
    [REMOTE_CONFIG_KEYS.XP_CURVE_BASE]: 100,
    [REMOTE_CONFIG_KEYS.XP_CURVE_INCREMENT]: 50,
    [REMOTE_CONFIG_KEYS.IAP_PACK_SMALL_COINS]: 5000,
    [REMOTE_CONFIG_KEYS.IAP_PACK_MEDIUM_COINS]: 25000,
    [REMOTE_CONFIG_KEYS.IAP_PACK_MEDIUM_GEMS]: 10,
    [REMOTE_CONFIG_KEYS.IAP_PACK_LARGE_COINS]: 60000,
    [REMOTE_CONFIG_KEYS.IAP_PACK_LARGE_GEMS]: 30,
    [REMOTE_CONFIG_KEYS.IAP_ROLLOUT_PERCENTAGE]: 100,
    // Module 50 (WP-50.25) — 100 → 10. One of five surfaces that must agree; the
    // others are the Mock provider's DEV_DEFAULTS, portal-config.json,
    // STARTING_COINS_FALLBACK and migration 0012's allowlist branch.
    // Module 97 — 10 → 100 with the ×10 coin scale (migration 0022).
    [REMOTE_CONFIG_KEYS.STARTING_COINS]: 100,
};
